const UPDATE_LEADS_IN_BACKGROUND_SUCCEEDED = 'leads/table/UPDATE_LEADS_IN_BACKGROUND_SUCCEEDED';

const FETCH_LEADS_MOBILE = 'leads/table/FETCH_LEADS_MOBILE';
const FETCH_LEADS_MOBILE_SUCCEEDED = 'leads/table/FETCH_LEADS_MOBILE_SUCCEEDED';
const FETCH_LEADS = 'leads/table/FETCH_LEADS';
const FETCH_LEADS_STATUS = 'leads/table/FETCH_LEADS_STATUS';
const FETCH_LEADS_STATUS_SUCCEEDED = 'leads/table/FETCH_LEADS_STATUS_SUCCEEDED';

const FETCH_PUBLISHER = 'leads/table/FETCH_PUBLISHER';
const FETCH_PUBLISHER_SUCCEEDED = 'leads/table/PUBLISHER_SUCCEEDED';
const FETCH_PUBLISHER_FAILED = 'leads/table/FETCH_PUBLISHER_FAILED';

const FETCH_LEADS_SUCCEEDED = 'leads/table/FETCH_LEADS_SUCCEEDED';
const FETCH_LEADS_SUCCEEDED_OTHER = 'leads/table/FETCH_LEADS_SUCCEEDED_OTHER';
const FETCH_LEADS_SUCCEEDED_PHONECALL = 'leads/table/FETCH_LEADS_SUCCEEDED_PHONECALL';
const FETCH_LEADS_SUCCEEDED_WH = 'leads/table/FETCH_LEADS_SUCCEEDED_WH';
const FETCH_LEADS_SUCCEEDED_EMAIL = 'leads/table/FETCH_LEADS_SUCCEEDED_EMAIL';

const FETCH_LEADS_FAILED = 'leads/table/FETCH_LEADS_FAILED';
const FETCH_LEADS_MOBILE_SUCCEEDED_UPDATE_EVENT = 'leads/table/FETCH_LEADS_MOBILE_SUCCEEDED_UPDATE_EVENT';
const SELECTED_LEAD = 'leads/table/SELECTED_LEAD';
const UNSELECTED_ALL_LEADS = 'leads/table/UNSELECTED_ALL_LEADS';

const FECTH_LEAD_UPDATE_STATUS = 'leads/table/FECTH_LEAD_UPDATE_STATUS ';
const FECTH_LEAD_UPDATE_STATUS_FAILED = 'leads/table/FECTH_LEAD_UPDATE_STATUS_FAILED ';
const FECTH_LEAD_UPDATE_STATUS_SUCCEEDED = 'leads/table/FECTH_LEAD_UPDATE_STATUS_SUCCEEDED ';

const UPDATE_LEAD_STATUS_FAVORITE = 'leads/table/UPDATE_LEAD_STATUS_FAVORITE';
const UPDATE_LEAD_STATUS_FAVORITE_SUCCEEDED = 'leads/table/UPDATE_LEAD_STATUS_FAVORITE_SUCCEEDED';
const UPDATE_LEAD_STATUS_FAVORITE_FAILED = 'leads/table/UPDATE_LEAD_STATUS_FAVORITE_FAILED';

const UPDATE_LEAD_STATUS = 'leads/table/UPDATE_LEAD_STATUS';
const UPDATE_LEAD_STATUS_SUCCEEDED = 'leads/table/UPDATE_LEAD_STATUS_SUCCEEDED';
const UPDATE_LEAD_STATUS_FAILED = 'leads/table/UPDATE_LEAD_STATUS_FAILED';

const SHOW_SNACKBAR = 'leads/table/SHOW_SNACKBAR';
const HIDE_SNACKBAR = 'leads/table/HIDE_SNACKBAR';

const CHANGE_PAGE = 'leads/table/CHANGE_PAGE';

const CHANGE_FILTER = 'leads/table/CHANGE_FILTER';

const UPDATE_LEADS_STATUS_SUCCEEDED_MOBILE = 'leads/table/UPDATE_LEADS_STATUS_SUCCEEDED_MOBILE';

const NOT_SHOW_LOADING = 'leads/table/NOT_SHOW_LOADING';
const CHANGE_TAB_OPTION = 'leads/table/CHANGE_TAB_OPTION';
const RESET_TAB_OPTION = 'leads/table/RESET_TAB_OPTION';
const UPDATE_TAB_OPTION = 'leads/table/UPDATE_TAB_OPTION';
const UPDATE_TAB_NEW = 'leads/table/UPDATE_TAB_NEW';
const UPDATE_TAB_NEW_FALSE = 'leads/table/UPDATE_TAB_NEW_FALSE';
const UPDATE_TAB_DISPLAY = 'leads/table/UPDATE_TAB_DISPLAY';

export {
  NOT_SHOW_LOADING,
  CHANGE_PAGE,
  UPDATE_LEADS_STATUS_SUCCEEDED_MOBILE,
  UPDATE_LEADS_IN_BACKGROUND_SUCCEEDED,
  UPDATE_LEAD_STATUS_FAVORITE,
  UPDATE_LEAD_STATUS_FAVORITE_SUCCEEDED,
  UPDATE_LEAD_STATUS_FAVORITE_FAILED,
  FETCH_LEADS_MOBILE,
  FETCH_LEADS_MOBILE_SUCCEEDED,
  FETCH_LEADS_MOBILE_SUCCEEDED_UPDATE_EVENT,
  FETCH_LEADS,
  FETCH_LEADS_FAILED,
  FETCH_LEADS_SUCCEEDED,
  SELECTED_LEAD,
  UNSELECTED_ALL_LEADS,
  UPDATE_LEAD_STATUS,
  UPDATE_LEAD_STATUS_SUCCEEDED,
  UPDATE_LEAD_STATUS_FAILED,
  SHOW_SNACKBAR,
  HIDE_SNACKBAR,
  CHANGE_TAB_OPTION,
  RESET_TAB_OPTION,
  UPDATE_TAB_OPTION,
  UPDATE_TAB_NEW,
  UPDATE_TAB_NEW_FALSE,
  UPDATE_TAB_DISPLAY,
  FETCH_LEADS_STATUS,
  FETCH_LEADS_STATUS_SUCCEEDED,
  FECTH_LEAD_UPDATE_STATUS,
  FECTH_LEAD_UPDATE_STATUS_FAILED,
  FECTH_LEAD_UPDATE_STATUS_SUCCEEDED,
  FETCH_PUBLISHER,
  FETCH_PUBLISHER_SUCCEEDED,
  FETCH_PUBLISHER_FAILED,
  CHANGE_FILTER,
  FETCH_LEADS_SUCCEEDED_OTHER,
  FETCH_LEADS_SUCCEEDED_PHONECALL,
  FETCH_LEADS_SUCCEEDED_WH,
  FETCH_LEADS_SUCCEEDED_EMAIL
};
